export default __webpack_public_path__ + "static/media/newarrival1.905cfd0a.png";